<script lang="ts">
  import { _ } from 'svelte-i18n';

  import CustomerListPanel from '$lib/components/CustomerListPanel.svelte';

  /**
   * The list door's first question: show us who you already sell to.
   *
   * # The same panel the exclusion step uses
   *
   * Uploading, watching the matching and taking the list back are already built
   * and already have a component. Nothing about this door needs a different
   * uploader — it needs the same list, read a second way, which is the next
   * step's job.
   *
   * # Why the file is asked for first and not last
   *
   * The `exclude` step asks for a list at the end of the other doors, because
   * there it subtracts and there is nothing to subtract from until the
   * selection exists. Here the same file is the input to the whole search, so
   * it comes first — and this door has no `exclude` step at the end, because
   * the file has already been given and is applied as the exclusion once the
   * findings are accepted.
   */
</script>

<!--
  Centred in the card rather than hard against its left edge. The column is
  `max-w-2xl` inside a `max-w-5xl` card, so without `mx-auto` it sat in the
  left two-thirds with a third of the card empty beside it — which reads as
  the layout having failed rather than as a deliberate measure.

  The hint goes above the panel, not below it.

  The panel ends with the way to adopt an existing list by code, so a line of
  guidance about which columns help landed under an unrelated control and read
  as belonging to it. Above, it is what it is: the last thing said before the
  thing to do.
-->
<div class="mx-auto max-w-2xl space-y-4">
  <p class="text-xs leading-relaxed text-gray-500">{$_('guided.listUpload.hint')}</p>

  <CustomerListPanel roomy />
</div>
